import React from 'react';
import { ERoutes } from '../types';
import Auth from '../components/auth/Auth';
import AuthLayout from '../layouts/AuthLayout';

const AuthRoutes = {
  path: ERoutes.home,
  element: <AuthLayout />,
  children: [
    {
      path: `${ERoutes.auth}/:tab?`,
      element: <Auth />,
    },
  ],
};

export default AuthRoutes;
